<img src="assets/fake_carousels.png" />

<div class="dialog-container">
  <opac-reset-password-dialog #resetPasswordDialog (submit)="handleResetPasswordDialog()"></opac-reset-password-dialog>
</div>
